// LiveKit Cloud Configuration
const LIVEKIT_URL = import.meta.env.VITE_LIVEKIT_URL || '';
const LIVEKIT_API_KEY = import.meta.env.VITE_LIVEKIT_API_KEY || '';
const LIVEKIT_API_SECRET = import.meta.env.VITE_LIVEKIT_API_SECRET || '';

// Validate config, throw error if invalid
if (!LIVEKIT_URL) {
  throw new Error('VITE_LIVEKIT_URL is required');
}
if (!LIVEKIT_API_KEY) {
  throw new Error('VITE_LIVEKIT_API_KEY is required');
}
if (!LIVEKIT_API_SECRET) {
  throw new Error('VITE_LIVEKIT_API_SECRET is required');
}

// export config
export const LiveKitConfig = {
  url: LIVEKIT_URL,
  apiKey: LIVEKIT_API_KEY,
  apiSecret: LIVEKIT_API_SECRET,
};
